
import React, { useEffect, useState } from "react";
import Card from 'components/Card/Card'
import axios from "axios";
import apiUrl from "../../../variables/api";

import {
    Text,
    Flex,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Button,
    Textarea,
    RadioGroup,
    Stack,
    SimpleGrid,
    AbsoluteCenter,
    Center,
    useColorModeValue, useColorMode,
    Skeleton
} from "@chakra-ui/react";
import {Field, Form, Formik} from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import ReactSelect from "react-select";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import darkStyles from "variables/darkStyles"

const initialValues = {
    dateTime: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, -8),
    while: "",
    injuredRescuer: "",
    kppGave: "",
    damages: "",
    aAResult: "",
    witnesses: "",
};

const validate = (values) => {
    const errors = {};
    const requiredFields = [
        "dateTime",
        "while",
        "injuredRescuer",
        "kppGave",
        "damages",
        "aAResult",
        "witnesses"
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = "To pole jest obowiazkowe";
        }
    });

    return errors;
}

function Page() {

    const [peoples, setPeoples] = useState([])
    useEffect(()=>{
        axios.get(apiUrl + '/data/peoples', {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
            .then(response => {
                console.log(response.data)
               setPeoples(response.data)
            })
            .catch(error => {
                console.error(error);
            });
    }, [])

    const [formData, setFormData] = useState(initialValues);
    const formikRef = React.useRef();
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        console.log('Dane formularza', values)

        setFormData(values);
        axios.post(apiUrl + '/data/minorAccident', values, {
            headers: {'x-access-token': localStorage.getItem('token')}
        })
            .then(response => {
                if (response.data.success) {
                    formikRef.current.resetForm()
                    formikRef.current.setSubmitting(false)
                    return toast.success('Pomyślnie wysłano meldunek o wypadku lekkim')
                } else {
                  formikRef.current.setSubmitting(false)
                  return toast.error('Napotkano błąd podczas wysyłania meldunku o wypadku lekkim')
                }
            })
            .catch(error => {
                console.error(error);
                formikRef.current.setSubmitting(false)
                toast.error('Napotkano błąd podczas połączenia z API')
            });
    };

    return (
        <Flex flexDirection='column' pt={{ base: "120px", md: "75px" }}>
            <Card minH='125px'>
                <Formik
                    initialValues={initialValues}
                    validate={validate}
                    onSubmit={handleSubmit}
                    innerRef={formikRef}
                >
                    {({ isSubmitting, formik }) => (
                        <Form>
                            <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing='24px' mb='20px'>
                            <Field name="dateTime">
                                {({ field, form }) => (
                                    <FormControl id="dateTime" isRequired isInvalid={form.errors.dateTime && form.touched.dateTime}>
                                        <FormLabel>Data i godzina</FormLabel>
                                        <Input type="datetime-local" {...field} placeholder="Data i godzina" />
                                        <FormErrorMessage>{form.errors.dateTime}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>
                                <Field name="while">
                                    {({ field, form }) => (
                                        <FormControl id="while" isRequired isInvalid={form.errors.while && form.touched.while}>
                                            <FormLabel>Podczas</FormLabel>
                                            <Input {...field} placeholder="Czynność" />
                                            <FormErrorMessage>{form.errors.while}</FormErrorMessage>
                                        </FormControl>
                                    )}
                                </Field>
                            <Field name="injuredRescuer">
                                {({ field, form }) => (
                                    <FormControl id="injuredRescuer" isRequired isInvalid={form.errors.injuredRescuer && form.touched.injuredRescuer}>
                                        <FormLabel>Wypadkowi uległ ratownik</FormLabel>
                                        <ReactSelect
                                            {...field}
                                            noOptionsMessage={() => "Brak dostępnych opcji"}
                                            options={peoples}
                                            isLoading={peoples.length === 0}
                                            placeholder="Wybierz..."
                                            styles={darkStyles()}
                                            value={form.values.injuredRescuer}
                                            onChange={(selectedOptions) => {
                                                form.setFieldValue(field.name, selectedOptions)
                                            }}
                                        />
                                        <FormErrorMessage>{form.errors.injuredRescuer}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>
                                <Field name="kppGave">
                                    {({ field, form }) => (
                                        <FormControl id="kppGave" isRequired isInvalid={form.errors.kppGave && form.touched.kppGave}>
                                            <FormLabel>KPP poszk. udzielił</FormLabel>
                                            <Input {...field} placeholder="Nick/nazwa" />
                                            <FormErrorMessage>{form.errors.kppGave}</FormErrorMessage>
                                        </FormControl>
                                    )}
                                </Field>
                            <Field name="damages">
                                {({ field, form }) => (
                                    <FormControl id="damages" isRequired isInvalid={form.errors.damages && form.touched.damages}>
                                        <FormLabel>Obrażenia</FormLabel>
                                        <Textarea {...field} placeholder="Treść" maxH={"500px"}/>
                                        <FormErrorMessage>{form.errors.damages}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>
                                <Field name="aAResult">
                                    {({ field, form }) => (
                                        <FormControl id="aAResult" isRequired isInvalid={form.errors.aAResult && form.touched.aAResult}>
                                            <FormLabel>Wskutek</FormLabel>
                                            <Textarea {...field} placeholder="Treść" maxH={"500px"}/>
                                            <FormErrorMessage>{form.errors.aAResult}</FormErrorMessage>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name="witnesses">
                                    {({ field, form }) => (
                                        <FormControl id="witnesses" isRequired isInvalid={form.errors.witnesses && form.touched.witnesses}>
                                            <FormLabel>Świadkami byli</FormLabel>
                                            <Textarea {...field} placeholder="Treść" maxH={"500px"}/>
                                            <FormErrorMessage>{form.errors.witnesses}</FormErrorMessage>
                                        </FormControl>
                                    )}
                                </Field>
                            </SimpleGrid>

                            <Button
                                mt={4}
                                colorScheme="red"
                                isLoading={isSubmitting}
                                type="submit"
                            >
                                Wyślij
                            </Button>

                        </Form>
                    )}
                </Formik>
            </Card>
        </Flex>
    );
}

export default Page;